import type { FC } from 'react';
import React from 'react';

import { ContentHeaderPresenceLoader } from '@confluence/team-presence/entry-points/ContentHeaderPresenceLoader.tsx';
import type { ContentHeaderPresenceProps } from '@confluence/team-presence/entry-points/presenceTypes.ts';

type PresenceProps = {
	contentMode: string | undefined;
	isViewMode?: boolean;
} & Omit<ContentHeaderPresenceProps, 'analyticSource'>;

export const Presence: FC<PresenceProps> = ({
	collaborators,
	contentId,
	contentType,
	contentMode,
	isViewMode,
}) => {
	return (
		<ContentHeaderPresenceLoader
			collaborators={collaborators}
			contentId={contentId}
			contentType={contentType}
			isViewMode={isViewMode}
			analyticSource={contentMode === 'view' ? 'viewPageScreen' : 'editPageScreen'}
		/>
	);
};
